import React, { useEffect, useState } from "react";
import "./myOrderCard.scss";
import { Avatar, Button, Divider, Rating, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import productStore from "../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../constant/index";
import dateFormat from "dateformat";
import orderDeliveryStatusTimeStore from "../../store/orderDeliveryStatusTimeStore";
import ProductRatingDialog from "../productRatingDialog/ProductRatingDialog";
import productRatingStore from "../../store/productRatingStore";
import orderReturnRequestStore from "../../store/orderReturnRequestStore";

// Icon
import { MdOutlinePending } from "react-icons/md";
import { ImMakeGroup } from "react-icons/im";
import { GiStorkDelivery, GiReturnArrow } from "react-icons/gi";
import { BsBox2Fill } from "react-icons/bs";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import AgricultureIcon from "@mui/icons-material/Agriculture";

const MyOrderCard = ({ item }) => {
  const navigate = useNavigate();
  const ProductStore = productStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const ProductRatingStore = productRatingStore();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const [product, setProduct] = useState(null);
  const [deliveryStatusIcon, setDeliveryStatusIcon] = useState();
  const [orderStatusDetail, setOrderStatusDetail] = useState(null);

  const [ratingValue, setRatingValue] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [alreadyRating, setAlreadyRating] = useState(false);

  const [deliveryDate, setDeliveryDate] = useState();
  const [returnAvailable, setReturnAvailable] = useState(false);
  const [returningProcess, setReturningProcess] = useState(null);

  useEffect(() => {
    OrderDeliveryStatusTimeStore.orderDeliveryStatusTime.map((status) => {
      if (status._id === item.orderDeliveryStatusTimeID) {
        setOrderStatusDetail(status);
        if (item.order_delivery_status === "Pending") {
          setDeliveryStatusIcon(<MdOutlinePending className="icon" />);
        } else if (item.order_delivery_status === "Preparing") {
          setDeliveryStatusIcon(<ImMakeGroup className="icon" />);
        } else if (item.order_delivery_status === "In Transit") {
          setDeliveryStatusIcon(<AgricultureIcon className="icon" />);
        } else if (item.order_delivery_status === "Out Of Delivery") {
          setDeliveryStatusIcon(<GiStorkDelivery className="icon" />);
        } else if (item.order_delivery_status === "Delivered") {
          setDeliveryStatusIcon(<BsBox2Fill className="icon" />);
          var myDate = new Date(status.delivered);
          myDate.setDate(myDate.getDate() + 7);
          setDeliveryDate(myDate);
          if (myDate >= new Date()) {
            setReturnAvailable(true);
          }
        } else if (item.order_delivery_status === "Return") {
          setDeliveryStatusIcon(<GiReturnArrow className="icon" />);
          setReturnAvailable(true);
        } else if (item.order_delivery_status === "Cancelled") {
          setDeliveryStatusIcon(<CancelIcon className="icon" />);
        }
      }
    });

    if (ProductStore.mProduct) {
      for (let i = 0; i < ProductStore.mProduct.length; i++) {
        if (ProductStore.mProduct[i]._id === item.productID) {
          setProduct(ProductStore.mProduct[i]);
          if (ProductRatingStore.myReview) {
            ProductRatingStore.myReview.map((r) => {
              if (r.productID === ProductStore.mProduct[i]._id) {
                setRatingValue(r.rating);
                setAlreadyRating(true);
              }
            });
          }

          break;
        }
      }
    }

    if (OrderReturnRequestStore.orderReturnRequest) {
      OrderReturnRequestStore.orderReturnRequest.map((returnItem) => {
        if (returnItem.orderID === item._id) {
          setReturningProcess(returnItem);
        }
      });
    }
  }, []);

  return (
    <div className="my-order-card">
      <Stack
        spacing={2}
        direction="row"
        sx={{
          borderBottom: "1px solid #c3e0e5",
          pb: 1,
          transition: "all 0.5s ease",
        }}
      >
        <Avatar className="avatar">
          {deliveryStatusIcon && deliveryStatusIcon}
        </Avatar>
        <div className="delivery-status-and-date">
          <div className="delivery-status">
            {item.order_delivery_status === "Return"
              ? item.order_delivery_status + "ed"
              : item.order_delivery_status}
          </div>

          <div className="delivery-date">
            {item.order_delivery_status === "Pending"
              ? "Wait for Owner accept - within 24 hours"
              : orderStatusDetail && orderStatusDetail.cancelled
                ? dateFormat(
                    new Date(orderStatusDetail.cancelled),
                    "dd mmm yyyy - hh:MM TT",
                  )
                : orderStatusDetail && orderStatusDetail.returning
                  ? dateFormat(
                      new Date(orderStatusDetail.returning),
                      "dd mmm yyyy - hh:MM TT",
                    )
                  : orderStatusDetail && orderStatusDetail.delivered
                    ? dateFormat(
                        new Date(orderStatusDetail.delivered),
                        "dd mmm yyyy - hh:MM TT",
                      )
                    : orderStatusDetail && orderStatusDetail.out_of_delivery
                      ? dateFormat(
                          new Date(orderStatusDetail.out_of_delivery),
                          "dd mmm yyyy - hh:MM TT",
                        )
                      : orderStatusDetail &&
                        (orderStatusDetail.in_transit ||
                          orderStatusDetail.preparing) &&
                        `${dateFormat(
                          new Date(orderStatusDetail.preparing),
                          "dd mmm yyyy - hh:MM TT",
                        )} and Delivery within ${product && product.deliverDays}`}
          </div>
        </div>
      </Stack>
      <div
        className="order-product"
        onClick={() =>
          navigate(product && `${item._id}/${product.productName}/details`)
        }
      >
        <Stack spacing={2} direction="row">
          <div className="order-product-image">
            <img
              src={product && `${PRODUCT_IMAGE_URL}${product.productImages[0]}`}
              alt="order-image"
            />
          </div>
          <div className="order-product-basic-details">
            <div className="order-product-name">
              {product && product.productName}
            </div>
            <div className="order-product-description">
              {product && product.productSubDescription}
            </div>
            {/* <div className="order-product-size">Size: {item.selectedSize}</div>
            <div className="order-product-color">
              Color: {item.selectedColor.toString()}
            </div> */}
          </div>
        </Stack>
      </div>
      {(item.order_delivery_status === "Delivered" ||
        item.order_delivery_status === "Return") && (
        <>
          <Divider />
          <div className="return-product">
            {returnAvailable ? (
              <div className="is-return">
                {returningProcess ? (
                  returningProcess.is_return_cancel ? (
                    "Your return order has cancel on " +
                    dateFormat(
                      returningProcess.cancel_return_date,
                      "dd mmm yyyy",
                    )
                  ) : returningProcess.order_returning_status === false &&
                    returningProcess.order_return_status === false ? (
                    <p>Returning process start within 24 hours.</p>
                  ) : returningProcess.order_returning_status === true &&
                    returningProcess.order_return_status === false ? (
                    <p>We will pick up return order within 7 days.</p>
                  ) : returningProcess.order_returning_status === false &&
                    returningProcess.order_return_status === true ? (
                    <p>
                      The product has returned successfully on{" "}
                      {dateFormat(
                        returningProcess.order_return_at,
                        "dd mmm yyyy",
                      )}
                      .
                    </p>
                  ) : (
                    ""
                  )
                ) : (
                  <p>
                    Return til{" "}
                    {orderStatusDetail &&
                      dateFormat(deliveryDate, "dd mmm yyyy")}
                  </p>
                )}
              </div>
            ) : (
              <p>
                Return window closed on{" "}
                {orderStatusDetail && dateFormat(deliveryDate, "dd mmm yyyy")}
              </p>
            )}
          </div>
          <Divider />
          <div className="product-rating">
            <p>Rate Product</p>
            <Rating
              name="order-product-rating"
              className="order-product-rating"
              icon={<StarRateRoundedIcon fontSize="inherit" />}
              emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
              value={ratingValue}
              readOnly={alreadyRating}
              onChange={(event, newValue) => {
                setRatingValue(newValue);
                if (newValue !== null) {
                  setOpenDialog(true);
                }
              }}
            />
          </div>
          <ProductRatingDialog
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            ratingValue={ratingValue}
            setRatingValue={setRatingValue}
            productID={item.productID}
          />
        </>
      )}
    </div>
  );
};

export default MyOrderCard;
